export enum PathErrorCodes {
  ASSET_METADATA_NOT_FOUND = 'AssetMetadataNotFound',
  NOT_DIRECTORY = 'InvalidDirectory',
}

export const isPathErrorCode = (code: PathErrorCodes): boolean => Object.values(PathErrorCodes).includes(code);
